var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXvs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.494 8.669-10.98 19.016a3.78 3.78 0 0 1-6.541 0l-1.925-3.331a.04.04 0 0 1 .037-.062.04.04 0 0 1 .027.015 3.162 3.162 0 0 0 4.956-.659l9.191-15.936a3.165 3.165 0 0 0-1.928-4.636.04.04 0 0 1-.001-.078h3.895a3.78 3.78 0 0 1 3.269 5.669zm-12.998-5.67H13.69a.04.04 0 0 0 0 .074 1.91 1.91 0 0 1 .97 2.727l-5.548 9.597a1.913 1.913 0 0 1-2.918.46.04.04 0 0 0-.026-.015.038.038 0 0 0-.03.007.04.04 0 0 0-.008.055l1.95 3.38a2.493 2.493 0 0 0 4.32 0L19.66 6.74A2.494 2.494 0 0 0 17.495 3zM4.284 3a3.284 3.284 0 1 0 0 6.569 3.284 3.284 0 0 0 0-6.57z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXvs);
export default __webpack_public_path__ + "static/media/XVS.8a05fe22ac5cd1ffd47403938ece3ef0.svg";
export { ForwardRef as ReactComponent };